import { WizCommand } from '@wizeoo/akm-component-lib';
import { DataLoadObj } from '@wizeoo/akm-compute-lib';
import { AkmBDD, LocalFei } from '@wizeoo/akm-worker-lib';
import { DataMessage } from '../../manager/baselines/data.message';
import { Model } from '../../model/model';

/** chargement des FEIs du cache */
export class LocalDataCommand extends WizCommand<any> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  public dlo: DataLoadObj; // la conf d'appel

  /**
   * Recherche des visions du domain pour le user connecté
   */
  public getLocal(dlo: DataLoadObj, callback: Function): LocalDataCommand {
    
    this.dlo = dlo;
    this.configure(callback, true);
    return this;
  }

  public wizExecute(): Promise<any> {
    
    this.model.dataMessage.doMessage(DataMessage.LOAD_LOCAL_INIT, this.dlo);
    this.dlo.startTime = new Date().getTime(); // début mesure

    return AkmBDD.getInstance().doGetFei(this.dlo.uniqueKey, 
      { key: this.dlo.uniqueKey, level: this.dlo.visionStep.level, scen: this.dlo.scenario, 
        revisionNumber: -1, localBaselines: {}
      });
  }

  wizResult() {
    const local : LocalFei = this.result;
    this.dlo.revisionNumber = local.revisionNumber || -1;
    this.dlo.localBaselines = local.localBaselines;
    this.dlo.localLoaded = true;
    this.dlo.state = DataLoadObj.LOADING; // on va passer à l'étape chargement remote
    this.dlo.endTime = new Date().getTime(); // fin mesure
    this.dlo.totalLocalTime = (this.dlo.endTime - this.dlo.startTime)/1000;

    this.model.dataMessage.doMessage(DataMessage.LOAD_LOCAL_ENDED, this.dlo);
    super.wizResult(); 
  }
}
